/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RoomEventSchema } from '../models/RoomEventSchema';
import type { RoomResourceSchema } from '../models/RoomResourceSchema';
import type { VisitStatus } from '../models/VisitStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CalendarRoomsApi {
    /**
     * Get Room Event List
     * Get room event list for rooms.<br>Required permission: get_room_event_list
     * @returns RoomEventSchema OK
     * @throws ApiError
     */
    public static calendarGetRoomEventListGet({
        start,
        end,
        roomIds,
        statuses,
    }: {
        /**
         * When to start filtering.
         */
        start: string,
        /**
         * When to end filtering.
         */
        end: string,
        /**
         * A list of room ids.
         */
        roomIds: Array<string>,
        /**
         * Only return visits in these statuses. Omit for all statuses.
         */
        statuses?: (Array<VisitStatus> | null),
    }): CancelablePromise<Array<RoomEventSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/calendar-rooms/events/',
            query: {
                'start': start,
                'end': end,
                'statuses': statuses,
                'room_ids': roomIds,
            },
        });
    }
    /**
     * Get Room Resource List
     * Get user company resources.<br>Required permission: get_resource_list
     * @returns RoomResourceSchema OK
     * @throws ApiError
     */
    public static calendarGetRoomResourceListGet(): CancelablePromise<Array<RoomResourceSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/calendar-rooms/resources/',
        });
    }
}
